const state = {
  phoneNumber: '',
  captchaObj: {},
  startCountDown: false,
  userInfo: {},
  provinceInfo: {},
  cityInfo: {},
  districtInfo: {},
  provinceData: [],
  cityData: [],
  districtData: [],
  schoolData: [],
  applyInfo: {}
}

const mutations = {
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo
  },
  SET_PROVINCE_INFO(state, provinceInfo) {
    state.provinceInfo = provinceInfo
  },
  SET_CITY_INFO(state, cityInfo) {
    state.cityInfo = cityInfo
  },
  SET_DISTRICT_INFO(state, districtInfo) {
    state.districtInfo = districtInfo
  },
  SET_APPLY_INFO(state, applyInfo) {
    state.applyInfo = applyInfo
  }
}

const actions = {}

export default {
  state,
  actions,
  mutations
}
